import * as types from '../../../../lib/actionTypes.es6'

export function getUssdSessionsRequest(msisdn) {
  return { type: types.GET_USSD_SESSIONS_REQUEST, payload: msisdn }
}
export function getUssdSessionsSuccess(sessions) {
  return { type: types.GET_USSD_SESSIONS_SUCCESS, payload: sessions }
}
export function getUssdSessionsFail(error) {
  return { type: types.GET_USSD_SESSIONS_FAIL, payload: error }
}

export function getUssdMessagesRequest(msisdn) {
  return { type: types.GET_USSD_MESSAGES_REQUEST, payload: msisdn }
}
export function getUssdMessagesSuccess(messages) {
  return { type: types.GET_USSD_MESSAGES_SUCCESS, payload: messages }
}
export function getUssdMessagesFail(error) {
  return { type: types.GET_USSD_MESSAGES_FAIL, payload: error }
}

export function getUssdFlowsRequest() {
  return { type: types.GET_USSD_FLOWS_REQUEST }
}
export function getUssdFlowsSuccess(flows) {
  return { type: types.GET_USSD_FLOWS_SUCCESS, payload: flows }
}
export function getUssdFlowsFail(error) {
  return { type: types.GET_USSD_FLOWS_FAIL, payload: error }
}

export function simulateStartRequest(flow, msisdn) {
  return { type: types.SIMULATE_START_REQUEST, payload: { flow, msisdn } }
}
export function simulateStartSuccess(runContext) {
  return { type: types.SIMULATE_START_SUCCESS, payload: runContext }
}
export function simulateStartFail(error) {
  return { type: types.SIMULATE_START_FAIL, payload: error }
}

export function simulateResumeRequest(msisdn, session, input) {
  return {
    type: types.SIMULATE_RESUME_REQUEST,
    payload: { msisdn, session, input }
  }
}
export function simulateResumeSuccess(runContext) {
  return { type: types.SIMULATE_RESUME_SUCCESS, payload: runContext }
}
export function simulateResumeFail(error) {
  return { type: types.SIMULATE_RESUME_FAIL, payload: error }
}

export function simulateReset() {
  return { type: types.SIMULATE_RESET }
}
